import React from 'react';

import { LinearProgress, Switch } from '@material-ui/core';

import { ErrorOutlineIcon } from 'assets/icons/alert';
import EditIcon from 'assets/icons/edit';

import { isNumeric } from '../utils';
import { Enum } from './enum';

export class AdGroupStatus extends Enum {
    #icon;

    static items = [];

    static UNDEFINED = new AdGroupStatus('', -1);
    static UNSPECIFIED = new AdGroupStatus('UNSPECIFIED', 0, () => <ErrorOutlineIcon />);
    static UNKNOWN = new AdGroupStatus('UNKNOWN', 1, <ErrorOutlineIcon />);
    static ENABLED = new AdGroupStatus('PUBLISHED', 2, () => <Switch color='primary' checked={true} dir='rtl' />);
    static PAUSED = new AdGroupStatus('PAUSED', 3, () => <Switch checked={false} />);
    static REMOVED = new AdGroupStatus('REMOVED', 4, () => <ErrorOutlineIcon />);
    static MISCELLANEOUS = new AdGroupStatus('MIXED STATUS', 5);
    static FAILED = new AdGroupStatus('FAILED', 6, () => <ErrorOutlineIcon />);
    static INPROGRESS = new AdGroupStatus(
        'IN PROGRESS',
        8,
        <LinearProgress color='primary' style={{ width: '35px' }} />
    );

    static ENQUEUED_TO_PUBLISH = new AdGroupStatus(
        'QUEUED',
        20,
        <LinearProgress color='primary' style={{ width: '35px' }} />
    );
    static DRAFT = new AdGroupStatus('DRAFT', 21, <EditIcon fontSize='small' />);

    constructor(name, value, icon = null) {
        super(name, value);

        this.#icon = icon;
        AdGroupStatus.items.push(this);
    }

    /**
     *
     */

    equals(other) {
        return this.value === other.value && this.name === other.name;
    }

    /**
     *
     */

    get icon() {
        return this.#icon;
    }
    /**
     *
     */

    static find(criteria) {
        if (isNumeric(criteria)) {
            return AdGroupStatus.items.find((v) => v.value === Number(criteria));
        }

        return AdGroupStatus.items.find((v) => v.name === criteria);
    }

    /**
     *
     */

    static contains(criteria) {
        const status = AdGroupStatus.find(criteria);

        return !!status;
    }

    /**
     *
     */

    static get(criteria) {
        return AdGroupStatus.find(criteria) || AdGroupStatus.UNDEFINED;
    }
}
